import {axiosInstance} from "@/plugins/axios";

export interface ProductsFilter {
  month: string,
  search: string | null,
}

export interface ProductPayload {
  month: string,
  id: string,
}

export async function getProducts(payload: ProductsFilter) {
  let url = `products?`;

  if (payload.month) {
    url += `month=${payload.month}&`;
  }

  if (payload.search && payload.search !== "") {
    url += `search=${payload.search}&`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getProduct(payload: ProductPayload) {
  let url = `products/${payload.id}?`;

  if (payload.month) {
    url += `month=${payload.month}&`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}
